module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-header01@2x.89ed8375.jpg";